module.exports = __webpack_public_path__ + "static/media/educationIcon.bcf490a5.png";